<!-- 详情信息 -->
<template>
  <div id='appTable'>
    <app-title>资料</app-title>
    <table align='left' style="border-collapse:collapse;" v-loading="loading" >
      <tr class="head">
        <th v-for="(item, index) in titles" :key="index">{{item.value}}</th>
        <th v-if="$route.query.grade!==undefined">操作</th>
      </tr>
      <tr v-for="(item, index) in contents" :key="index" class="body">
        <td v-for="(i, v) in titles" :key="v" :class="{'pointer': i.key==='name'&& String($route.query.grade)=='undefined'}" @click="goDetail(v, item)">
          <img :src="item.url" alt="file" :class="item.url.includes('file') ? 'files': 'file'" v-if="i.key==='name'"> {{item[i.key]}}
        </td>
        <td v-if="$route.query.grade!==undefined" class="pointer">
          <a class="download" download :href="item.content" target="_blank">下载</a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { getSuffix } from '@/utils/filter.js'
export default {
  data () {
    return {
      suffixUrl: ''
    }
  },
  props: {
    titles: Array,
    contents: [Object, Array],
    loading: Boolean
  },
  components: {},
  watch: {
    contents () {
      if (Array.isArray(this.contents)) {
        this.contents.forEach(v => {
          v.url = getSuffix(v.suffix)
        })
      }
    }
  },
  methods: {
    goDetail (index, item) {
      if (index === 0 && String(this.$route.query.grade) === 'undefined') {
        this.$emit('detail', item)
      }
    },
    download (item) {
      item.content && window.open(`${item.content}`)
    }
  }
}
</script>
<style scoped lang='scss'>
#appTable {
  table {
    display: block;
    width: 100%;
    text-align: left;
    margin-top: 28px;
    margin-bottom: 60px;
    th,
    td {
      text-align: left;
      padding: 0 20px;
      font-size: 14px;
      &:first-child {
        width: 400px;
      }
      &:nth-child(2) {
        width: 118px;
      }
      &:nth-child(3) {
        width: 180px;
      }
      &:nth-child(4) {
        width: 136px;
      }
      .files {
        width: 18px;
        height: 16px;
        vertical-align: middle;
        margin-right: 5px;
      }
      .file {
        width: 18px;
        height: 20px;
        vertical-align: middle;
        margin-right: 5px;
      }
      .download {
        display: inline-block;
        line-height: 28px;
        text-align: center;
        width: 50px;
        height: 28px;
        color: #3d9afe;
        border: 1px solid rgba(61, 154, 254, 1);
        border-radius: 4px;
        font-style: none;
      }
    }
    .head {
      height: 48px;
      background: rgba(247, 249, 250, 1);
      font-size: 14px;
      color: #666;
    }
    .body {
      height: 58px;
      border-bottom: 1px solid rgba(239, 242, 245, 1);
    }
  }
}
</style>
